export const EMAIL_VERIFICATION = "/email-verification";
export const POSA_PRICES = "/publicposa";
export const PUBLIC_PRICES = "/prices";
export const VALIDATE = "/validate";
export const LEGAL = "/legal";
export const CONTACT = "/contact";
export const COLORTEST = "/colorstests";
export const SIGNUP = "/signup";

export const OTHERS = "/*";
export const MAIN = "/";
export const LOTTERY_STATS = "/lotterystats";

export const ONBOARDING = "/onboarding";
export const ONBOARDING_WITH_TRACKING = "/:trackingID/onboarding";

export const subscriptionByQuote = "/subByQuote";
export const subscriptionByQuoteWithTrackingID = "/:trackingID/subByQuote";

export const SAAS_FLYERS_ORDER = "/saas-flyers-order";
export const SAAS_FLYERS_ORDER_WITH_TRACKING_ID =
  "/:trackingID/saas-flyers-order";

export const SUBSCRIPTION = "/subscription";
export const SUBSCRIPTION_WITH_TRACKING = "/:trackingID/subscription";

export const ANALYTICS = "/analytics";
export const ANALYTICS_WITH_TRACKING_ID = "/:trackingID/analytics";

export const MONTHLY_STATS = "/monthly-stats";
export const MONTHLY_STATS_WITH_TRACKING = "/:trackingID/monthly-stats";

export const MONTHLY_STATS_DETAIL = "/monthly-stats/detail";
export const MONTHLY_STATS_DETAIL_WITH_TRACKING =
  "/:trackingID/monthly-stats/detail";

export const JETPACK_CONFIG = "/config";
export const JETPACK_CONFIG_WITH_TRACKING = "/:trackingID/config";

export const POSA = "/posa";
export const POSA_WITH_TRACKING_ID = "/:trackingID/posa";

export const POSA_WITH_DELIVERY_ID = "/posa/:deliveryId";

export const BILLS = "/bills";
export const BILLS_WITH_TRACKING = "/:trackingID/bills";

export const FORM_DATA = "/form_data";
export const FORM_DATA_WITH_TRACKING = "/:trackingID/form_data";

export const configAnimation = "/configuration";
export const configAnimationWithTracking = "/:trackingID/configuration";

export const distribution = "/configuration/distribution";
export const distributionWithTracking =
  "/:trackingID/configuration/distribution";

export const posaDistributionQuantity = "/configuration/distribution/quantity";
export const posaDistributionQuantityWithTracking =
  "/:trackingID/configuration/distribution/quantity";

export const posaDistributionQuantityInfo =
  "/configuration/distribution/quantity/info";
export const posaDistributionQuantityInfoWithTracking =
  "/:trackingID/configuration/distribution/quantity/info";

export const ACCOUNT = "/account";
export const ACCOUNT_WITH_TRACKING_ID = "/:trackingID/account";
